// Get all the checkboxes with class "input.add-on-product-checkbox"
var checkboxes = document.querySelectorAll('input.add-on-product-checkbox');

// Add an input event listener to each checkbox
checkboxes.forEach(function (checkbox) {
  checkbox.addEventListener('input', function () {
    // Retrieve the data-variant attribute value
    var variant = checkbox.getAttribute('data-variant');

    // Check the state of the checkbox
    if (checkbox.checked) {
      updateCart(1, variant);
    } else {
      updateCart(0, variant);
    }
  });
});

// Function to update the cart
function updateCart(value, variant) {
  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    body: `updates[${variant}]=${value}`
  })
    .then(response => {
      if (response.ok) {
        location.reload(); // Refresh the page
      } else {
        // Handle error case if needed
      }
    })
    .catch(error => {
      // Handle error case if needed
    });
}

// Function to update the variant id
function updateVariant(selectElement) {
  var selectedOption = selectElement.options[selectElement.selectedIndex];
  var variantId = selectedOption.getAttribute('data-variant');
  var inputElement = selectElement.parentElement.parentElement.parentElement.parentElement.querySelector('input.add-on-product-checkbox');
  inputElement.setAttribute('data-variant', variantId);
}